export class TableSampleCell {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableSampleCell.attributeTypeMap;
    }
    constructor() {
    }
}
